import juice from 'juice';

const INLINE_STYLES_MAX_HTML_LENGTH = 512 * 1024;

export function inlineStyles(html: string) {
  if (html.includes('</style>') && html.length <= INLINE_STYLES_MAX_HTML_LENGTH) {
    try {
      return juice(removeStyleComments(html), {
        preserveFontFaces: false,
        preserveKeyFrames: false,
        preserveMediaQueries: false,
        preservePseudos: false,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error while inlining styles`, error);
    }
  }

  return html;
}

function removeStyleComments(html: string): string {
  // Attempt to remove HTML comment wrappers from style tags, except if it's an IE conditional.
  return html.replace(/(<style>\s*)<!--(\s*[^[])/gi, '$1$2');
}
